import { useState } from 'react';
import { FloatingActionButton } from '@/components/FloatingActionBar/FloatingActionButton';
import { HubIcon } from '@/components/Hub/HubIcon';
import { HubPanel } from '@/components/Hub/HubPanel';

/**
 * The Hub entry point. An open affordance rather than a toggle. The dock hides itself while a
 * sheet is open so the panel is closed by its own close button, an overlay click or Escape.
 */
export const HubFab = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            {/* `aria-haspopup`, not the `aria-expanded` and `aria-controls` the context bar this
                replaced used. That bar expanded a panel beside its button. The Hub is a modal
                sheet, which Radix unmounts when closed, so `aria-controls` would name an element
                that is not there. */}
            <FloatingActionButton
                label="Open the Hub"
                aria-haspopup="dialog"
                onClick={() => setIsOpen(true)}
                data-track-click="Hub Clicked"
                data-track-location="floating-action-bar"
                data-track-button-name="hub"
            >
                <HubIcon />
            </FloatingActionButton>
            <HubPanel open={isOpen} onOpenChange={setIsOpen} />
        </>
    );
};
